import LeadScoreChart from './LeadScoreChart'
import { animate } from 'framer-motion'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { useEffect, useRef, useState } from 'react'
import { RiComputerLine, RiCursorFill } from 'react-icons/ri'
import * as Styles from './Lead.module.css'

const Lead = ({
  companyLogo,
  companyName = '',
  leadName = '',
  industryCategory = '',
  numberOfEmployees = '',
  leadScore = 18,
  tracking = [],
  className,
}) => {
  const Counter = useRef()
  const [animateLeadScore, setLeadScore] = useState(0)
  useEffect(() => {
    const controls = animate(0, leadScore, {
      duration: (3 * leadScore) / 100,
      delay: 0.5,
      onUpdate(value) {
        setLeadScore(value.toFixed(0))
      },
    })
    return () => controls.stop()
  }, [leadScore])

  const handleColor = (number) => {
    if (number < 20) return { accent: 'text-red-500', neutral: 'bg-red-50' }
    if (number < 40)
      return { accent: 'text-orange-500', neutral: 'bg-orange-50' }
    if (number < 60) return { accent: 'text-sky-500', neutral: 'bg-sky-50' }
    if (number < 80) return { accent: 'text-blue-500', neutral: 'bg-blue-50' }

    return { accent: 'text-green-400', neutral: 'bg-green-50' }
  }

  const chartColor = handleColor(leadScore)

  return (
    <div className={`${Styles.wrapper} ${className && className}`}>
      <div className={Styles.leadBasicInfo}>
        <div className={Styles.leadImage}>
          <div className="bg-red-220">
            {companyLogo && (
              <GatsbyImage
                objectFit="cover"
                alt={companyName}
                image={getImage(companyLogo)}
              />
            )}
          </div>
        </div>

        <div>
          <div className={Styles.companyName}>{companyName}</div>
          <div>{leadName}</div>
        </div>
      </div>

      <div className={Styles.tracking}>
        <div>
          <RiComputerLine /> {tracking.sessions} <span>sessions</span>
        </div>
        <div className={Styles.text}>
          <RiCursorFill />
          {tracking.events} <span>events</span>
        </div>
      </div>

      <div className={Styles.companyInfoWrapper}>
        <div>{industryCategory}</div>
        <div className={Styles.text}>
          {numberOfEmployees} <span className="text-gray-300">Employees</span>
        </div>
      </div>

      <div className={`${Styles.leadScoreChart} ${chartColor.neutral}`}>
        <LeadScoreChart
          leadScore={leadScore}
          animateLeadScore={animateLeadScore}
          className={chartColor.accent}
        />
        <div
          className={`${Styles.leadScore} ${chartColor.accent}`}
          ref={Counter}
        >
          {animateLeadScore}
        </div>
      </div>
    </div>
  )
}

export default Lead
